import { useEffect } from 'react';

import { PaintBoardIcon } from '@hugeicons/core-free-icons';
import patternValidators from 'helpers/validators/pattern-validators';
import { Controller, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { AnimatedModal } from 'components/AnimatedModal/AnimatedModal';
import { Button, Input, InputGroup } from 'components/FormComponents';
import { ImagePicker } from 'components/FormComponents/ImagePicker/ImagePicker';

export const CreateBrandModal = ({ visible, onClose, onSubmit, isSubmitting = false }) => {
  const { t } = useTranslation();
  const {
    register,
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    if (!visible) reset();
  }, [visible, reset]);

  return (
    <AnimatedModal
      visible={visible}
      onClose={onClose}
      title={t('branding.createModal.title')}
      description={t('branding.createModal.description')}
      icon={PaintBoardIcon}
      oldIconLibrary={false}
      small>
      <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-2">
        <InputGroup
          title={t('branding.createModal.brandName')}
          description="Internal name used to identify this brand in the dashboard.">
          <Input
            name="name"
            placeholder="e.g. Internal employee"
            register={register}
            validators={{ required: true }}
            error={errors?.name?.type}
          />
        </InputGroup>

        <InputGroup
          title="Display Name"
          description="Public-facing name shown to candidates and external users.">
          <Input
            name="brand_name"
            placeholder="e.g. Checkmate tech"
            register={register}
            validators={{ required: true }}
            error={errors?.brand_name?.type}
          />
        </InputGroup>

        <InputGroup title={t('branding.createModal.brandEmail')} optional>
          <Input
            name="brand_email"
            placeholder="e.g. noreply@acme.com"
            register={register}
            validators={patternValidators.email}
            error={errors?.brand_email?.message}
          />
        </InputGroup>

        <InputGroup title={t('branding.createModal.brandLogo')} optional>
          <Controller
            name="brand_logo_id"
            control={control}
            render={({ field: { onChange, value } }) => (
              <ImagePicker onChange={onChange} value={value} />
            )}
          />
        </InputGroup>

        <div className="flex justify-end gap-2 mt-2">
          <Button type="secondary" onClick={onClose}>
            {t('branding.createModal.close')}
          </Button>
          <Button submit disabled={isSubmitting}>
            {isSubmitting ? t('branding.createModal.creating') : t('branding.createModal.create')}
          </Button>
        </div>
      </form>
    </AnimatedModal>
  );
};
